import React from 'react';
import '../Styles/WhyUS.css'
import { GiPriceTag,GiStumpRegrowth } from "react-icons/gi";
import { MdOutlineProductionQuantityLimits,MdOutlineSupportAgent } from "react-icons/md";
import { FiSunrise } from "react-icons/fi";
import { SiEasyjet } from "react-icons/si";
const WhyUs = () => {
    return (
        <div className='whyUs lg:py-10'>
             <div>
                <h5 className='text-center font-bold'>WHY CHOOSE US</h5>
                <h1 className='text-center text-5xl font-bold p-5 lg:px-96'>Get Benefits & Advantages</h1>
            </div>
            <div className='service'>
                <div class="single-collection">
                    <article class="itemblog">
                    <p className='text-center'>
                    <GiPriceTag className='icon'/>
                    </p>
                        <h4>Competitive Price</h4>

                        <p>This lightweight tripod allows you to make photos and videos without having to hold the
                            camera steady yourself.</p>
                    </article>
                    <article class="itemblog">
                        <GiStumpRegrowth className='icon'/>
                        <h4>Growth Stratagy</h4>

                        <p>A microphone, colloquially called a mic or mike (/maɪk/), is a device – a transducer – that
                            converts sound into an electrical signal</p>
                    </article>
                    <article class="itemblog">
                        <MdOutlineProductionQuantityLimits className='icon'/>
                        <h4>Quality Product</h4>

                        <p>With the Noise Air Buds Mini Truly Wireless Bluetooth earbuds, you can take calls, groove to
                            your favourite music, or exercise to adrenaline-pumping hits.</p>
                    </article>
                    <article class="itemblog">
                        <FiSunrise className='icon'/>
                        <h4>Our Responsibility</h4>

                        <p>A drone is an unmanned aircraft. Drones are more formally known as unmanned aerial vehicles
                            (UAVs) or unmanned aircraft systems.</p>
                    </article>
                    <article class="itemblog">
                        <MdOutlineSupportAgent className='icon' />
                        <h4>24/7 Support</h4>

                        <p>When setting up your vehicle lighting, it is well worth considering how and where you will be
                            using your new lights in order to choose the right setup.</p>
                    </article>
                    <article class="itemblog">
                        <SiEasyjet  className='icon'/>
                        <h4>Easy To Use</h4>

                        <p>When setting up your vehicle lighting, it is well worth considering how and where you will be
                            using your new lights in order to choose the right setup.</p>
                    </article>
                </div>
            </div>
        </div>
    );
};

export default WhyUs;